export const getReserveRateApi = (params,query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/reserve_accounts/${queryString ? `?${queryString}` : ''}`;
}
export const getConstantApi = () => {
    return `lease/constants/get_by_constant_types`;
}
export const getMajorAssemblyApi = (params) => {
    return `console/${params?.leaseSlug}/major-assembly`;
}
export const getMaintenanceEventApi = (assetType,assetId) => {
    return `config/maintenance-checks/${assetType}/${assetId}/`;
}
export const getCurrencyApi = () => {
    return `/console/currency/`;
}
export const getEngineLLPApi = (assetType,assetSlug,query) => {
    return `console/asset/${assetType}/${assetSlug}/llp/?for_reserve_account=${query? query : "module"}&is_llp_replacement=true`;
}

export const addReserveRateApi = (params) => {
    return `lease/${params?.leaseSlug}/reserve_accounts/`;
};

export const updateReserveRateApi = (params) => {
    return `lease/${params?.leaseSlug}/reserve_accounts/`;
};

export const deleteReserveRateApi = (params) => {
    return `lease/${params?.leaseSlug}/reserve_accounts/`;
};

export const exportReserveRateApi = (leaseId) => {
    return `lease/${leaseId}/reserve_accounts/export/`;
};

export const reserveRatefileUploadPostApi = (reserveRateSlug) => {
    return `lease/reserve_account/${reserveRateSlug}/attachments`;
};

export const reserveRateChangeStatus = (leaseId)=>{
    return `lease/${leaseId}/reserve_accounts/update_status/`;
    
}

export const getInvoiceConfigApi = (params) => {
    return `lease/${params?.leaseSlug}/reserve_rate/invoice-configuration`
}

export const updateInvoiceConfigApi = (params) => {
    return `lease/${params?.leaseSlug}/reserve_rate/invoice-configuration`
}

export const getBankDropdown =(lessor_id)=>{
    return `api/dropdown/banks/?lessor_id=${lessor_id}`
}

export const getMuicpRateApi = (params,query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/inflation-rates/${queryString ? `?${queryString}` : ''}`;
}

export const addMuicpRateApi = (params) => {
    return `lease/${params?.leaseSlug}/inflation-rates/`;
};

export const updateMuicpRateApi = (params) => {
    return `lease/${params?.leaseSlug}/inflation-rates/`;
};

export const deleteMuicpRateApi= (params) => {
    return `lease/${params?.leaseSlug}/inflation-rates/`;
};

export const exportMuicpRateApi= (leaseId) => {
    return `lease/${leaseId}/inflation-rates/export/`;
};

export const reserveRatesfileUploadPostApi = (reserve_rates_slug) => {
    return `/get-pre-signed-url/reserve_rates/${reserve_rates_slug}`;
};

export const reserveRatesAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/reserve_rates/${attachments_slug}`
}

export const getOpeningBalanceApi = (params,query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/reserve-opening-balances/${queryString ? `?${queryString}` : ''}`;
}

export const addOpeningBalanceApi = (params) => {
    return `lease/${params?.leaseSlug}/reserve-opening-balances/`;
};

export const updateOpeningBalanceApi = (params) => {
    return `lease/${params?.leaseSlug}/reserve-opening-balances/${params?.slug}/`;
};

export const deleteOpeningBalanceApi = (params) => {
    return `lease/${params?.leaseSlug}/reserve-opening-balances/`;
};

export const sortReserveRateApi = (params) => {
    return `lease/${params?.leaseSlug}/reserve-accounts/sort/`;
};

export const getEscalationDetailsApi =(params, reserveSlug)=>{
    return `/lease/${params?.leaseSlug}/reserve_accounts/${reserveSlug}/escalation/`
}

export const getEngineThrustApi = (engineTypeId) => {
    return `config/engine-types/?engine_family_engine_type=${engineTypeId}&for_thrust=true`;
}

//get asset 
export const getAssetApi = (slug) => {
    return `/api/dropdown/asset/?asset_slug=${slug}&include_on_wing=true`;
}

export const sampleExportApi = (slug) => {
    return `/lease/${slug}/sample_export/`;
}

export const sampleFHFCRatioExportApi = (slug) => {
    return `/lease/${slug}/export_reserve_rates_table/`;
}

export const getProductServiceDropdownApi = (lessor_name_id) => {
    return `/integrations/quickbooks/products-services/?dropdown=true${lessor_name_id ? `&lessor_name_id=${lessor_name_id}` : ''}`;
}

export const getChartOfAccountDropdownApi = (lessor_name_id) => {
    return `/integrations/quickbooks/chart-of-accounts/?dropdown=true${lessor_name_id ? `&lessor_name_id=${lessor_name_id}` : ''}`;
}

export const getMaintenanceSVEventApi = (assetType,assetId) => {
    return `config/maintenance-checks/${assetType}/${assetId}/?is_sv=true`;
}